import Axios from 'axios'
import {
  getPostponedMaxDays,
  getPostponedMaxFollowUpDate,
  isPostponedCommunicationClass,
  validatePostponedFollowUp,
} from '@/helper/postponedCommunicationHelper'

export default {
  computed: {
    postponedCommunicationMaxDays() {
      return getPostponedMaxDays(this.$store.state.app_settings)
    },
    postponedMaxFollowUpDate() {
      return getPostponedMaxFollowUpDate(this.$store.state.app_settings)
    },
  },
  methods: {
    isPostponedCommunicationClassId(classId) {
      return isPostponedCommunicationClass(this.canonicalClassId(classId))
    },
    validatePostponedFollowUpForPayload(payload, activeClassId) {
      if (!this.isPostponedCommunicationClassId(activeClassId)) {
        return null
      }
      return validatePostponedFollowUp(payload, this.$store.state.app_settings)
    },
    showPostponedFollowUpError(message) {
      if (typeof this.showPopup === 'function') {
        this.showPopup('error', message)
        return
      }
      this.$store.state.popupError = message
    },
    activeRequestClassIdFromPayload(payload) {
      const isCs =
        parseInt(localStorage.getItem('role'), 10) === 0 &&
        localStorage.getItem('is_customer_service') === '1'

      if (isCs) {
        return parseInt(payload?.class_id_cs ?? payload?.class_id_agent, 10)
      }
      return parseInt(payload?.class_id_agent, 10)
    },

    /**
     * Re-sync overdue أجل التواصل state after save/send without page refresh.
     * Updates App.vue popup via root event and returns local follow-up validation.
     */
    async recheckPostponedFollowUpAfterAction(payload = null) {
      const role = localStorage.getItem('role')
      if (role !== '0') {
        return { overdueList: [], followUpError: null }
      }

      let overdueList = []
      try {
        const response = await Axios.get(
          `${this.$store.state.url}/v2/employee/Requests/postponed-communication/overdue`,
          { headers: this.request_headers() }
        )
        overdueList = response.data?.payload?.requests || []
      } catch (e) {
        overdueList = []
      }

      this.$root.$emit('postponed-overdue-sync', overdueList)

      const info = payload || this.$store.state.request_info
      if (!info || !info.id) {
        return { overdueList, followUpError: null }
      }

      const activeClassId = this.activeRequestClassIdFromPayload(info)
      const followUpError = this.validatePostponedFollowUpForPayload(info, activeClassId)

      this.$root.$emit('postponed-followup-validated', {
        requestId: info.id,
        followUpError,
        overdueList,
      })

      return { overdueList, followUpError }
    },

    /** Call after save/send: wait for RD refresh then re-validate follow-up. */
    schedulePostponedFollowUpRecheckAfterRefresh() {
      let done = false
      const run = (payload = null) => {
        if (done) return
        done = true
        clearTimeout(fallbackId)
        this.$root.$off('request-details-refreshed', run)
        this.recheckPostponedFollowUpAfterAction(payload || this.$store.state.request_info)
      }
      const fallbackId = setTimeout(() => run(null), 1500)
      this.$root.$once('request-details-refreshed', run)
      this.$root.$emit('RD')
    },
  },
}
